import { useState, useEffect, useRef } from "react";
import './WizardSidebar.css';
import feather from "feather-icons";

const WizardSidebar = ({ steps, currentStep, goToStep }) => {
    const icons = ["/img/side_nav/business_seg.png", "/img/side_nav/product_lines.png", "/img/side_nav/geography.png", "/img/side_nav/competitiors.png", "/img/side_nav/categories_dimensions.png", "/img/side_nav/review.png"];
    const sidebarRef = useRef(null);
    const baseRef = useRef(null);
    const progressRef = useRef(null);
  
    useEffect(() => {
      feather.replace();
  
      const svgIcons = document.querySelectorAll(".sidebar-item img");
      svgIcons.forEach((svg, idx) => {
        svg.classList.remove("custom_text-muted", "custom_text-primary", "text-success");
        // if (currentStep === idx) svg.classList.add("custom_text-primary-back");
        // if (currentStep > idx) svg.classList.add("custom_text-primary");
        // else svg.classList.add("custom_text-muted");
      });
  
      const items = sidebarRef.current?.querySelectorAll(".sidebar-item");
      if (!items?.length) return;
  
      const sidebarTop = sidebarRef.current.getBoundingClientRect().top;
  
      const getIconCenter = (item) => {
        const icon = item.querySelector("i");
        const rect = icon?.getBoundingClientRect();
        return rect ? rect.top - sidebarTop + rect.height / 2 : 0;
      };
  
      const firstY = getIconCenter(items[0]);
      const lastY = getIconCenter(items[items.length - 1]);
  
      // Set base line (gray)
      if (baseRef.current) {
        baseRef.current.style.top = `${firstY}px`;
        baseRef.current.style.height = `${lastY - firstY}px`;
      }
  
      // Set progress line (blue)
      if (progressRef.current) {
        const currentY =
          currentStep === 0 ? firstY : getIconCenter(items[currentStep - 1]);
        progressRef.current.style.top = `${firstY}px`;
        progressRef.current.style.height = `${currentY - firstY}px`;
      }
    }, [currentStep]);
  
    return (
      <div
        className="wizard-sidebar"
        ref={sidebarRef}
        // style={{ width: 290, minHeight: "100%" }}
      >
        {/* <div className="wizard-line-base" ref={baseRef}></div>
        <div className="wizard-line-progress" ref={progressRef}></div> */}
  
        {steps.map((step, idx) => {
          const isActive = currentStep === idx;
          const isCompleted = currentStep > idx;
  
          return (
            <div
              key={idx}
              className={`sidebar-item d-flex align-items-center ${
                isActive
                  ? "fw-bold custom_text-primary"
                  : isCompleted
                  ? "custom_text-primary"
                  : "custom_text-muted"
              }`}
              style={{
                cursor: "pointer", zIndex: 1,
                background: isActive ? 'linear-gradient(90deg, rgba(217, 229, 255, 0) 0%, #D9E5FF 100%)' : '',
                borderRight: isActive ? '3px solid #4E6BCA' : ''
              }}
              onClick={() => goToStep(idx)}
            >
              <span className={`circle_icon ${isActive || isCompleted ? 'custom_text-primary-back' : ''}`}>
                <img
                src={isCompleted ? icons[idx] : icons[idx]}
                className={`me-2 icon_step ${isActive || isCompleted ? 'completed_or_active' : ''}`} width="16"
              />
              </span>

                <div className="wizard-line-base" ref={baseRef}></div>
                <div className={` ${isCompleted ? 'wizard-line-progress custom_text-primary': 'custom_text-muted'}`} style={{marginTop: "10px"}} ref={progressRef}></div>
              <span className="step_name">{step}</span>
            </div>
          );
        })}
      </div>
    );
  };

export default WizardSidebar;